(function () {
    'use strict';
    var controllerId = 'dettaglioProgettoAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', '$uibModal', 'datacontext', '_', 'common', 'progetto', dettaglioProgettoAddEditFn]);

    function dettaglioProgettoAddEditFn($scope, $rootScope, $uibModalInstance, $uibModal, datacontext, _, common, progetto) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.item = {};
        $scope.progetto = progetto;

        $scope.disableField = !$rootScope.isAuthorized('PERSONALE');

        $scope.item.otherCostumer = false;
        $scope.item.clienti = getClienti();

        if ($scope.progetto.Id == 0) {
            $scope.titolo = 'New Project';
        }
        else {
            $scope.titolo = 'Edit Project';

            if ($scope.progetto.ClienteId == 0)
                $scope.item.otherCostumer = true;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                if ($scope.progetto.Id == 0) {
                    addItem($scope.progetto).then(function (result) {
                        if (result)
                            $uibModalInstance.close(result);
                    });
                }
                else {  // sono in modifica
                    editItem($scope.progetto).then(function (result) { 
                        if (result)
                            $uibModalInstance.close(result);
                    });
                }
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function getClienti() {
            datacontext.cliente_getAllList().then(function (data) {
                return $scope.item.clienti = data;
            });
        }

        // Modifica elemento
        function editItem(item) {
            if (!$scope.item.otherCostumer) {
                var index = _.findIndex($scope.item.clienti, { 'Id': item.ClienteId });
                if (index != -1)
                    item.Cliente = $scope.item.clienti[index].Name;
            } else
                item.ClienteId = 0;

            return datacontext.dettaglioProgetto_update(item).then(function (data) {
                if (data == "400") {
                    logError("Errore durante la creazione del dato");  
                    return null;
                }

                return data; 
            });
        }

        // Aggiunta elemento
        function addItem(item) {
            if (!$scope.item.otherCostumer) {
                var index = _.findIndex($scope.item.clienti, { 'Id': item.ClienteId });
                if (index != -1)
                    item.Cliente = $scope.item.clienti[index].Name;
            } else
                item.ClienteId = 0;

            return datacontext.dettaglioProgetto_add(item).then(function (data) {
                if (data == "400") {
                    logError("Errore durante la creazione del dato"); 
                    return null;
                }

                return data;  
            });
        }

        $scope.changeCostumer = function () {
            if ($scope.item.otherCostumer && $scope.progetto.ClienteId > 0)
                $scope.progetto.Cliente = '';
        };
    }
})();